import React from "react";
import PropTypes from "prop-types";

import { useSelector } from "react-redux";

import { ArticleItem } from "../ArticleItem/ArticleItem";

import { ListHeader, ArticleTable, ListBody } from "./style";

export const ArticleList = ({ articles }) => {
  const alias = useSelector((state) => state.init.alias);

  return (
    <ArticleTable>
      <ListHeader>
        <tr>
          <th colSpan="6">{alias.bfcArticles}</th>
          <th></th>
          <th></th>
          <th>{alias.bfcName}</th>
          <th>{alias.bfcArticleNumber}</th>
          <th>{alias.bfcAmount}</th>
          <th>{alias.bfcPrice}</th>
        </tr>
      </ListHeader>
      <ListBody>
        {/* Due to that there are articles with the same SKU's, use index aswell */}
        {articles.map((article, index) => (
          <ArticleItem article={article} key={`${article.Sku}${index}`} />
        ))}
      </ListBody>
    </ArticleTable>
  );
};

ArticleList.propTypes = {
  articles: PropTypes.array,
};
